const SESSION_KEY = '@prit-web/booking_origin';

const ORIGIN_RULES = [
  { param: 'rwg_token', origin: 'Google' },
  { param: 'fbclid', origin: 'Facebook' },
  { param: 'igshid', origin: 'Instagram' },
];

/**
 * Lê os parâmetros de rastreamento da URL e armazena a origem no sessionStorage.
 * Deve ser chamado o mais cedo possível no carregamento da página,
 * antes de qualquer redirecionamento interno.
 *
 * @param {string} search - window.location.search ou props.location.search
 */
export function captureBookingOrigin(search) {
  try {
    const params = new URLSearchParams(search);
    const matched = ORIGIN_RULES.find(({ param }) => params.get(param));
    if (matched) {
      sessionStorage.setItem(SESSION_KEY, matched.origin);
    }
  } catch (_) {
    // sessionStorage indisponível (ex: bloqueado pelo navegador) — falha silenciosa
  }
}

/**
 * Retorna a origem do agendamento com base no sessionStorage.
 * Prioridade: Google (rwg_token) > Facebook (fbclid) > Instagram (igshid) > Direto.
 *
 * @returns {'Google' | 'Facebook' | 'Instagram' | 'Direto'}
 */
export function getBookingOrigin() {
  try {
    return sessionStorage.getItem(SESSION_KEY) || 'Direto';
  } catch (_) {
    return 'Direto';
  }
}
